<template>
    <form @submit.prevent="submitForm">
        <div class="form-control" :class="{invalid: !firstName.isValid}">
            <label for="firstname">First Name</label>
            <input  type="text" id="firstname" v-model="firstName.val" @blur="clearValidity('firstName')"/>
          
        </div>
        <div class="form-control" :class="{invalid: !lastName.isValid}">
            <label for="lastname">Last Name</label>
            <input type="text" id="lastname" v-model.trim="lastName.val" @blur="clearValidity('lastName')"/>
        </div>
          <div class="form-control" :class="{invalid: !description.isValid}">
            <label for="description">Description</label>
            <textarea id="description" rows="5" v-model.trim="description.val" @blur="clearValidity('description')"></textarea>
        </div>
          <div class="form-control" :class="{invalid: !age.isValid}">
            <label for="age">Age</label>
            <input type="number" id="age" v-model.number="age.val" @blur="clearValidity('age')"/>
        </div>

          <div class="form-control" :class="{invalid: !achievements.isValid}">
              <h3>Achievements</h3>
              <div>
              <input type="checkbox" id="vendee_arctique" value="vendee_arctique" v-model="achievements.val" @blur="clearValidity('achievements')">
              <label for="vendee_arctique">Vendée Arctique</label>
              </div>
              <div>
              <input type="checkbox" id="transat_jacques_vabre" value="transat_jacques_vabre"
              v-model="achievements.val" @blur="clearValidity('achievements')">
               <label for="transat_jacques_vabre">Transat Jacques Vabre</label>
               </div>
               <div>
              <input type="checkbox" id="rolex_fastnet_race" value="rolex_fastnet_race" v-model="achievements.val" @blur="clearValidity('achievements')">
               <label for="rolex_fastnet_race">Rolex Fastnet Race</label>
               </div>
                 <div>
              <input type="checkbox" id="route_de_rhum" value="route_de_rhum" v-model="achievements.val" @blur="clearValidity('achievements')">
               <label for="route_de_rhum">Route de Rhum</label>
               </div>
                 <div>
              <input type="checkbox" id="bermudes_1000_race" value="bermudes_1000_race" v-model="achievements.val" @blur="clearValidity('achievements')">
               <label for="bermudes_1000_race">Bermudes 1000 Race</label>
               </div>     

                <div>
                 <input type="checkbox" id="others" value="others" v-model="achievements.val" @blur="clearValidity('achievements')">
                <label for="others">others</label>
                </div>
           </div>
           <p v-if="!formIsValid" :class="{ is_red: !formIsValid }">Please enter correct data and submit the form again.</p>

    <base-button>Register</base-button>

    </form>
</template>

<script>
export default {

    emits:['save-data'],

    data() {
        return {
            firstName: {
                val:'',
                isValid: true
            },
            lastName: {
                val:'',
                isValid: true
            },
            description: {
                val:'',
                isValid:true
            },
            age: {
                val:null,
                isValid:true

            },
            achievements: {
                val:[],
                isValid:true

            },
            formIsValid: true
        }
    },
    methods: {

        clearValidity(input) {      
            this[input].isValid = true;
            
        },

        validateForm() {
            this.formIsValid = true;

            if(this.firstName.val === ''){
                this.firstName.isValid = false;
                this.formIsValid = false;
            }
             if(this.lastName.val === ''){
                this.lastName.isValid = false;
                this.formIsValid = false;
            }
            if(this.description.val === ''){
                this.description.isValid = false;
                this.formIsValid = false;
            }
            if(!this.age.val || this.age.val < 0) {
                this.age.isValid = false;
                this.formIsValid = false;
            }
            if(this.achievements.val.length === 0) {
                this.achievements.isValid = false;
                this.formIsValid = false;
            }



        },

        submitForm() {
            this.validateForm()

            if(!this.formIsValid) {
                return;
            }

            const formData = {
                first: this.firstName.val,
                last: this.lastName.val,
                desc: this.description.val,
                age: this.age.val,
                achieve: this.achievements.val

            };

            this.$emit('save-data',formData); 
           
        },
          
    }
}

</script>

<style scoped>
.form-control {
  margin: 0.5rem 0;
}

label,p {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input[type='checkbox'] + label {
  font-weight: normal;
  display: inline;
  margin: 0 0 0 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  font: inherit;
}

input:focus,
textarea:focus {
  background-color: #f0e6fd;
  outline: none;
  border-color: #3d008d;
}

input[type='checkbox'] {
  display: inline;
  width: auto;
  border: none;
}

input[type='checkbox']:focus {
  outline: #3d008d solid 1px;
}

h3 {
  margin: 0.5rem 0;
  font-size: 1rem;
}

.invalid label, .is_red {
  color: red;
}

.invalid input,
.invalid textarea {
  border: 1px solid red;
}

</style>

